// routes
import { PATH_AUTH } from '../../routes/paths';

/* ============================================================================
   Itens do menu do site publico.

   O QUE ESTAVA AQUI: o menu de demonstracao do template Minimal, com SETE
   destinos que nao existem neste projeto - /components, /pages, /pricing,
   /payment, /about-us, /contact-us, /faqs, /coming-soon. O roteador manda o que
   nao casa para o 404 (src/app-routes.tsx), entao cada um desses itens era um
   link quebrado. Tinha ainda um submenu com "Login/Register" apontando para as
   rotas `-unprotected` (as duplicatas do template) e um "Documentation" que ia
   para docs-minimals.vercel.app, a documentacao do TEMPLATE - nao deste sistema.

   O QUE FICOU: somente destinos que existem de verdade. As rotas publicas deste
   projeto sao `/`, `/gpshub`, `/maintenance`, `/404`, `/500` e `/auth/*` - e
   dessas, as unicas que fazem sentido num menu sao a inicial, o gerador de senha
   e o login.

   Sem `Iconify` tambem: era o unico vinculo deste arquivo com MUI (via o Box de
   dentro do Iconify) e os icones do template nao diziam nada aqui - "grain" para
   Components, "file" para Pages. Tres itens de texto nao precisam de icone para
   serem distinguidos.

   ATENCAO DE ALCANCE: este menu praticamente nao e visto hoje. O layout main e
   pedido so por `/`, `/[token]` e `/dashboard` (index), e as tres renderizam
   LoadingScreen enquanto redirecionam - e a LoadingScreen e `position: fixed`
   com z-index alto, ou seja cobre o cabecalho. Ele existe para quando houver uma
   pagina publica de verdade.
   ============================================================================ */

const menuConfig = [
  {
    title: 'Início',
    path: '/',
  },
  {
    // A tela que gera a senha de acesso a partir da chave do dispositivo.
    title: 'Gerar senha de acesso',
    path: '/gpshub',
  },
  {
    title: 'Entrar',
    path: PATH_AUTH.login,
  },
];

export default menuConfig;
